<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import { EmbedVideo, Heading, Icon, Link, ProgressLine } from '@smatch/cassiopeia-web-components';

    // STORES
    import { ONBOARDING_STATE, ONBOARDING_PROGRESS } from '../store';

    // CONFIG
    import { CONFIG } from '../config';

    // STYLING
    import 'tailwindcss/tailwind.css';

</script>

<div class = 's8-wrap'>

    <Heading size = 'md'>Onboarding { $ONBOARDING_PROGRESS }% completed</Heading>
    <ProgressLine progress = { $ONBOARDING_PROGRESS } />

    <EmbedVideo source = 'https://www.loom.com/embed/b4fd8b7c100849bfaf288b285ef353aa' />

    <ul class = 's8-list'>

        {#each CONFIG as { key, label, text, hash }}

            <li class:s8-off = { $ONBOARDING_STATE[key] }>

                {#if $ONBOARDING_STATE[key] }
                    <Icon key = 'check' />
                {/if}

                <p>
                    <Link url = { hash }>
                        { label }<br /><small>{ text }</small>
                    </Link>
                </p>

                {#if $ONBOARDING_STATE[key] }
                    <Link url = { hash }>
                        edit
                    </Link>
                {:else}
                    <Link url = { hash }>
                        <Icon key = 'chevronRight' />
                    </Link>
                {/if}

            </li>

        {/each}

    </ul>

</div>


<style lang='postcss'>

    div.s8-wrap {

        ul.s8-list {

            display: flex;
            flex-direction: column;
            row-gap: 26px;
            margin-top: 20px;
            margin-bottom: 20px;

            li {
                display: flex;
                align-items: flex-start;
                column-gap: 10px;

                &.s8-off {
                    opacity: 0.25;
                }

                :global(svg) {
                    width: 12px;
                }

                :global(*) {
                    line-height: 1;
                }

                p {
                    flex: 1;
                    line-height: 1;
                }
            }
        }
    }

</style>